import $ from 'jquery/src/jquery'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const nodeSelectors = {
        container: '[js-shape="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        let containers = document.querySelectorAll(nodeSelectors.container)

        containers.forEach(function (container, index) {
            ScrollTrigger.create({
                trigger: container,
                pin: false,
                markers: false,
                start: "top 50%",
                end: "bottom 0%",
                scrub: 0,
                invalidateOnRefresh: true,
                onEnter: () => {
                    $(container).addClass('shape--animate')
                },
                onEnterBack: () => {
                    $(container).addClass('shape--animate')
                },
                onLeave: () => {
                    // $(nodeSelectors.container).removeClass('shape--animate')
                },
                onLeaveBack: () => {
                    // $(nodeSelectors.container).removeClass('shape--animate')
                },
            });
        })
    }

    return Object.freeze({
        init,
    })
}